module.exports = __webpack_public_path__ + "static/media/flexible-lg--image-4.d7194e62.jpg";